import {
  scheduledOriginCellFromTicketsHop,
  scheduledOriginCellFromCheckoutHop,
} from './cell/ScheduledOriginCell'
import {
  scheduledDetailCellFromTicketsHop,
  scheduledDetailCellFromCheckoutHop,
} from './cell/ScheduledDetailCell'
import {
  scheduledDestinationCellFromTicketsHop,
  scheduledDestinationCellFromCheckoutHop,
} from './cell/ScheduledDestinationCell'
import {
  layoverCellFromTicketsHop,
  layoverCellFromTicketsLeg,
  layoverCellFromCheckoutHop,
} from './cell/LayoverCell'
import {
  transferCellFromTicketsHop,
  transferCellFromCheckoutHop,
} from './cell/TransferCell'
import { vehicleFromTicketsHop } from '../api/schedule/hop'

/**
 * Creates a Timeline (Cell[]) for a Segment within a Route.
 *
 * Note: you can control whether or not TransferCells and InterchangeCells are emitted using
 * withTransfers and withInterchanges.
 *
 * @param {SearchResponse} response response from the API
 * @param legIndex (an absolute index)
 * @param hopIndex (an absolute index)
 * timeline. Default to false.
 * @returns {Cell[]} Timeline for the segment.
 */
const createTimelineForTicketsHop = (response, legIndex, hopIndex) => {
  const leg = response.legs[legIndex]
  const hop = response.hops[hopIndex]
  const relativeHopIndex = leg.hops.indexOf(hopIndex)

  const isFinalHop = relativeHopIndex === (leg.hops.length - 1)

  const vehicleKind = vehicleFromTicketsHop(response, hop)

  const result = []

  // if the hop is a transfer, instead push a new transfer cell
  if (hop.isTransfer) {
    result.push(transferCellFromTicketsHop(response, hopIndex))
  } else if (vehicleKind.kind === 'walk') {
    result.push(scheduledDetailCellFromTicketsHop(response, hopIndex))
  } else {
    result.push(scheduledOriginCellFromTicketsHop(response, hopIndex))
    result.push(scheduledDetailCellFromTicketsHop(response, hopIndex))
    result.push(scheduledDestinationCellFromTicketsHop(response, hopIndex))

    if (!isFinalHop && leg.layovers) {
      const nextHopIndex = leg.hops[relativeHopIndex + 1]
      const nextHop = response.hops[nextHopIndex]

      // Only add the layover if the next hop is not a walk and not a transfer
      if (vehicleFromTicketsHop(response, nextHop).kind !== 'walk' && !nextHop.isTransfer) {
        const layoverCell = layoverCellFromTicketsHop(response, leg, relativeHopIndex)
        if (layoverCell) {
          result.push(layoverCell)
        }
      }
    }
  }

  return result
}

export const createTimelineForTicketsLeg = (response, isOutbound, itineraryIndex, legIndex) => {
  const itinerary = isOutbound
    ? response.outboundItineraries[itineraryIndex]
    : response.inboundItineraries && response.inboundItineraries[itineraryIndex]
  const relativeLegIndex = itinerary.legs.indexOf(legIndex)

  const isFinalLeg = relativeLegIndex === (itinerary.legs.length - 1)

  const result = []
  response.legs[legIndex].hops.forEach((hopIndex) => {
    result.push(...createTimelineForTicketsHop(response, legIndex, hopIndex))
  })

  if (!isFinalLeg && itinerary.layovers) {
    const layoverCell = layoverCellFromTicketsLeg(response, itinerary, relativeLegIndex)
    result.push(layoverCell)
  }

  return result
}

export const createTimelineForCheckoutHop = (hops, hopIndex, operator) => {
  const result = []
  const hop = hops[hopIndex]
  if (hop.isTransfer) {
    result.push(transferCellFromCheckoutHop(hop, operator))
  } else {
    const previous = hopIndex > 0 ? hops[hopIndex - 1] : null
    if (previous && !previous.isTransfer) {
    const previousDay = previous.arrivalTime.substring(8, 10)
    const currentDay = hop.departureTime.substring(8, 10)
    const isOvernight = previousDay != currentDay
      result.push(layoverCellFromCheckoutHop(hop, isOvernight))
    }
    result.push(scheduledOriginCellFromCheckoutHop(hop))
    result.push(scheduledDetailCellFromCheckoutHop(hop, operator))
    result.push(scheduledDestinationCellFromCheckoutHop(hop))
  }

  return result
}
